import axios from "axios";
import React, { useCallback, useEffect, useMemo, useState } from "react";

/*BootstrapTable anbd table Related*/
import { Paper } from "@material-ui/core";
import { BootstrapTable } from "react-bootstrap-table";

export default function Selections({
  className = "",
  initialData = [],
  initialDataSelection = [],
  title,
  getUrl,
  getProcess,
  getSelectedUrl,
  getSelectedProcess = () => {},
  insertUrl,
  insertParams = () => {},
  insertAllUrl,
  insertAllParams = () => {},
  deleteUrl,
  deleteParams = () => {},
  deleteAllUrl,
  deleteAllParams = () => {},
  children,
}) {
  const userInfo = useMemo(
    () => JSON.parse(localStorage.getItem("userInfo")),
    []
  );

  const [data, setData] = useState(initialData);
  const [selected, setSelected] = useState(initialDataSelection);

  /**
   * GET
   */
  const requestData = useCallback(() => {
    const url =
      process.env.REACT_APP_API2_URL +
      (getUrl instanceof Function ? getUrl(userInfo) : getUrl);
    axios
      .get(url)
      .then((response) => response.data)
      .then((data) => {
        if (getProcess instanceof Function) {
          setData(getProcess(data));
        } else {
          setData(data);
        }
      });
  }, [getUrl, userInfo, getProcess]);

  const requestDataSelected = useCallback(() => {
    const url =
      process.env.REACT_APP_API2_URL +
      (getSelectedUrl instanceof Function
        ? getSelectedUrl(userInfo)
        : getSelectedUrl);
    axios
      .get(url)
      .then((response) => response.data)
      .then((data) => {
        setSelected(getSelectedProcess(data));
      });
  }, [getSelectedUrl, getSelectedProcess, userInfo]);

  /**
   * INSERT
   */
  const insertData = useCallback(
    (row) => {
      axios
        .post(
          process.env.REACT_APP_API2_URL +
            (insertUrl instanceof Function
              ? insertUrl(userInfo, row)
              : insertUrl),
          insertParams(userInfo, row)
        )
        .then((response) => response.data)
        .then(() => requestDataSelected());
    },
    [requestDataSelected, insertUrl, insertParams, userInfo]
  );

  /**
   * INSERT ALL
   */
  const insertAllData = useCallback(
    (rows) => {
      axios
        .post(
          process.env.REACT_APP_API2_URL +
            (insertAllUrl instanceof Function
              ? insertAllUrl(userInfo, rows)
              : insertAllUrl),
          insertAllParams(userInfo, rows)
        )
        .then((response) => response.data)
        .then(() => requestDataSelected());
    },
    [requestDataSelected, insertAllUrl, insertAllParams, userInfo]
  );

  /**
   * DELETE
   */
  const deleteData = useCallback(
    (row) =>
      axios
        .post(
          process.env.REACT_APP_API2_URL +
            (deleteUrl instanceof Function
              ? deleteUrl(userInfo, row)
              : deleteUrl),
          deleteParams(userInfo, row)
        )
        .then((response) => response.data)
        .then(() => requestDataSelected()),
    [requestDataSelected, deleteUrl, deleteParams, userInfo]
  );

  /**
   * DELETE ALL
   */
  const deleteAllData = useCallback(
    (rows) =>
      axios
        .post(
          process.env.REACT_APP_API2_URL +
            (deleteAllUrl instanceof Function
              ? deleteAllUrl(userInfo, rows)
              : deleteAllUrl),
          deleteAllParams(userInfo, rows)
        )
        .then((response) => response.data)
        .then(() => requestDataSelected()),
    [requestDataSelected, deleteAllUrl, deleteAllParams, userInfo]
  );

  /**
   * Initial load
   */
  useEffect(() => {
    if (getUrl) {
      requestData();
      requestDataSelected();
    }
  }, [getUrl, requestData, requestDataSelected]);

  const onSelect = useCallback(
    (row, selected, e) => (selected ? insertData(row) : deleteData(row)),
    [insertData, deleteData]
  );

  const onSelectAll = useCallback(
    (isSelected, rows) =>
      isSelected ? insertAllData(rows) : deleteAllData(rows),
    [insertAllData, deleteAllData]
  );

  const selectRowProp = {
    mode: "checkbox",
    selected,
    onSelect,
    onSelectAll,
    clickToSelect: true,
  };

  return (
    <div id="main-div" className={`${className} !h-max`}>
      <Paper>
        {title ? <h2>{title}</h2> : <></>}

        <BootstrapTable data={data} selectRow={selectRowProp} hover>
          {children}
        </BootstrapTable>
      </Paper>
    </div>
  );
}
